export default "__VITE_PUBLIC_ASSET__3e19feff__"